import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class ContactHistoryService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    let params = "json=" + json + "&authorization=" + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    let page = 1;

    return this._http.post<any>(
      this.url + '/contacthistory/new?page=' + page,
      params,
      { headers: headers }
    ).pipe(map(res => res));
  }

  getContactsUser(token, id, page = 1): Observable<any> {
    let params = "authorization=" + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(
      this.url + '/contacthistory/list/' + id + '?page=' + page,
      params,
      { headers: headers }
    ).pipe(map(res => res));
  }

  getContact(token, id): Observable<any> {
    let params = "authorization=" + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    let page = 1;

    return this._http.post<any>(
      this.url + '/contacthistory/detail/' + id + '?page=' + page,
      params,
      { headers: headers }
    ).pipe(map(res => res));
  }

  update(token, task, id): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    let params = "json=" + json + "&authorization=" + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    let page = 1;

    return this._http.post<any>(
      this.url + '/contacthistory/edit/' + id + '?page=' + page,
      params,
      { headers: headers }
    ).pipe(map(res => res));
  }

  deleteContact(token, id): Observable<any> {
    let params = "authorization=" + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    let page = 1;

    return this._http.post<any>(
      this.url + '/contacthistory/remove/' + id + '?page=' + page,
      params,
      { headers: headers }
    ).pipe(map(res => res));
  }
}
